// Re-exports from unified color system
import { PRIMITIVE_COLORS, SEMANTIC_COLORS } from '../residentColors';

export const RESIDENTS_DESKTOP_COLORS = {
  PRIMARY_BACKGROUND: SEMANTIC_COLORS.background.secondary,
  SECONDARY_BACKGROUND: SEMANTIC_COLORS.background.primary,
  CIRCLE_ICON_BACKGROUND: PRIMITIVE_COLORS.gray700,
  BUTTON_PRIMARY: PRIMITIVE_COLORS.resioBlue,
  BUTTON_SECONDARY: SEMANTIC_COLORS.text.primary,
  BUTTON_TERTIARY: PRIMITIVE_COLORS.resioPink,
  BUTTON_ACTIVE_PRIMARY: PRIMITIVE_COLORS.gray850,
  BORDER_PRIMARY: PRIMITIVE_COLORS.resioBlueLight,
  BORDER_SECONDARY: PRIMITIVE_COLORS.gray850,
  ICON_ACTIVE: '#F9FAFB',
  ICON_INACTIVE: '#9CA3AF',
  TEXT_PRIMARY: SEMANTIC_COLORS.text.primary,
  TEXT_SECONDARY: PRIMITIVE_COLORS.resioBlueLight,
  TEXT_TERTIARY: PRIMITIVE_COLORS.gray400,
  TEXT_SUCCESS: PRIMITIVE_COLORS.successGreen,
  TEXT_ATTENTION: PRIMITIVE_COLORS.resioBlueAttention,
  HOVER_PRIMARY: PRIMITIVE_COLORS.blackHover,
  ACCOUNT_TAB: PRIMITIVE_COLORS.resioBlue,
  linkedAccounts: {
    invitationTabsBorder: PRIMITIVE_COLORS.resioPurple,
    accountsTabsBorder: PRIMITIVE_COLORS.resioBlueLight,
    howTabsBorder: PRIMITIVE_COLORS.resioPink,
  },
} as const;
